import { Component, computed, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../shared/local-storage.service';
import { TrawlDelivery } from '../shared/trawl-delivery.model';

@Component({
    selector: 'app-trawl-drafts',
    templateUrl: './trawl-drafts.component.html',
    styleUrl: './trawl-drafts.component.css',
    standalone: false
})
export class TrawlDraftsComponent {

  drafts: Signal<TrawlDelivery[]>;
  
  
  constructor(public dataSync: LocalStorageService, public router: Router) { 
    this.drafts = computed(() => dataSync.trawl_drafts());

  }
  
   onDraftClick(index: number) {
      this.router.navigate(['trawl_delivery', 3, index], { queryParams: { previous: 'trawl_drafts' } })
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
    }
  
}
